/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ManeuverType {
    ESRI_DMT_TURN_LEFT = 'EsriDmtTurnLeft',
    ESRI_DMT_TURN_RIGHT = 'EsriDmtTurnRight',
    ESRI_DMT_BEAR_LEFT = 'EsriDmtBearLeft',
    ESRI_DMT_BEAR_RIGHT = 'EsriDmtBearRight',
    ESRI_DMT_SHARP_LEFT = 'EsriDmtSharpLeft',
    ESRI_DMT_SHARP_RIGHT = 'EsriDmtSharpRight',
    ESRI_DMT_STRAIGHT = 'EsriDmtStraight',
    ESRI_DMT_UTURN = 'EsriDmtUTurn',
    ESRI_DMT_ROUNDABOUT = 'EsriDmtRoundabout',
    ESRI_DMT_UNKNOWN = 'EsriDmtUnknown',
    ESRI_DMT_DEPART = 'EsriDmtDepart',
    ESRI_DMT_STOP = 'EsriDmtStop',
}
